<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/status-warning.svg?raw'
export default {
  name: 'IconStatusWarning',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
